import { ProductTabBlockListModel } from 'autogen/swagger/all';
import React from 'react';
import TabBlock from '../../shared/TabBlock';

export default function BlockList({ ...props }: ProductTabBlockListModel): JSX.Element {
    const { blocks } = props;

    return (
        <div>
            {blocks?.map((block, index) => {
                const { content } = block;
                if (!content) return null;

                return (
                    // eslint-disable-next-line react/no-array-index-key
                    <TabBlock key={index} {...block} />
                );
            })}
        </div>
    );
}
